import type { FaireProductEntity } from "../../entity_types/product";

export const p_pxctmbuyg9: FaireProductEntity = {
  token: "p_pxctmbuyg9",
  type: "product",
  name: "De La Rosa Mazapan Covered With Chocolate",
  brandToken: "b_6w2wcf7tpu",
  brandName: "Mr. YuYu's Chililicious Candy",
  imageUrl:
    "https://cdn.faire.com/fastly/fe61f9aa5cff5b69e17e89393aa26c2641bf598af0aab7c4b25fc53696cee9bd.jpeg",
  galleryImageUrls: [],
  priceDollars: 0.43,
  description:
    "De La Rosa Mazapan Covered With Chocolate 16 Count combines traditional Mexican marzipan with rich chocolate for a distinctive confectionery experience. Each piece delivers 20 grams of carbohydrates, offering a satisfying sweet treat with a balanced flavor and texture. Packaged in a 16-count set, this product is ideal for wholesale distribution, retail shelves, and specialty stores, providing a convenient option for sharing or personal enjoyment.\n\nKey Features\n\n * \n16-count pack optimized for wholesale distribution\n\n * \nTraditional marzipan coated in rich chocolate\n\n * \nEach piece contains 20 grams of carbohydrates\n\n * \nConvenient packaging suitable for sharing or individual consumption\n\n * \nIdeal for retail, convenience stores, and specialty food markets\n",
  tags: [],
  msrpDollars: 0.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:07.890Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
